export default "__VITE_ASSET__18b95e9f__"